import { critical } from 'services/ApplicationInsightsLog';
import { SelectListField } from './2-molecules/SelectListField';
import {
	CheckBoxList,
	DateTimePicker,
	GoogleMapSearch,
	IframeComponent,
	MitIdButton,
	PledgeButton,
	RadioList,
	ReadOnlyWarningModal,
	RichText,
	StateList,
	TextInput,
} from './index';

export const Component: React.FC<any> = (props) => {
	const components = {
		MitIdButton: MitIdButton,
		InputComponent: TextInput,
		GoogleMapsComponent: GoogleMapSearch,
		DropDownListComponent: () => <p>DropDownListComponent</p>, // future component?
		DateTimeComponent: DateTimePicker,
		InputListComponent: () => <p>InputListComponent</p>, // future component?
		GridListComponent: () => <p>GridListComponent</p>, // future component?
		ButtonListComponent: () => <p>ButtonListComponent</p>, // future component?
		RadioListComponent: RadioList,
		CheckboxListComponent: CheckBoxList,
		StateListComponent: StateList,
		RichTextComponent: RichText,
		FileUploadComponent: () => <p>FileUploadComponent</p>, // future component?
		IframeComponent: IframeComponent,
		ReadOnlyWarningModalComponent: ReadOnlyWarningModal,
		SelectListFieldComponent: SelectListField,
		PledgeButtonComponent: PledgeButton,
	};

	const DynamicComponent = components[props?.componentType as keyof typeof components];

	if (typeof DynamicComponent === 'undefined') {
		// Should it break in build?s
		critical(
			new Error(
				`Component [${props.componentType}] is missing a React Component. Check /components/Component.tsx`
			)
		);
		return (
			<div>{`Component [${props.componentType}] is missing a React Component. Check /components/Component.tsx`}</div>
		);
	}

	return <DynamicComponent {...props} />;
};
